import React from 'react';
import StringFieldProto from './url-proto.jsx';


export default function renderStringInList(id, props) {
    return <StringFieldProto renderMode="list" id={id} {...props} />;
}